import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFullScreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 8,
			fill: "black",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.59991 10.7241C6.93066 10.7241 7.19982 10.4549 7.19982 10.1242V7.40012C7.19982 7.28971 7.2897 7.19984 7.4001 7.19984H10.1241C10.4549 7.19984 10.724 6.93067 10.724 6.59992C10.724 6.26917 10.4549 6 10.1241 6H7.4001C6.6282 6 6 6.62821 6 7.40012V10.1242C6 10.4549 6.26916 10.7241 6.59991 10.7241Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_23485_81864",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 13,
			y: 6,
			width: 5,
			height: 5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M13.2422 6H18.0013V10.7884H13.2422V6Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_23485_81864)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M16.6013 6H13.8773C13.5465 6 13.2773 6.26917 13.2773 6.59992C13.2773 6.93067 13.5465 7.19984 13.8773 7.19984H16.6013C16.7117 7.19984 16.8015 7.28971 16.8015 7.40012V10.1242C16.8015 10.4549 17.0707 10.7241 17.4015 10.7241C17.7322 10.7241 18.0014 10.4549 18.0014 10.1242V7.40012C18.0014 6.62821 17.3732 6 16.6013 6Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_23485_81864",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 13,
			y: 13,
			width: 5,
			height: 5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M13.2422 13.2422H18.0013V18.0014H13.2422V13.2422Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_23485_81864)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M17.4015 13.2734C17.0707 13.2734 16.8015 13.5426 16.8015 13.8734V16.5974C16.8015 16.7078 16.7117 16.7977 16.6013 16.7977H13.8773C13.5465 16.7977 13.2773 17.0668 13.2773 17.3976C13.2773 17.7284 13.5465 17.9975 13.8773 17.9975H16.6013C17.3732 17.9975 18.0014 17.3693 18.0014 16.5974V13.8734C18.0014 13.5426 17.7322 13.2734 17.4015 13.2734Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask2_23485_81864",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 6,
			y: 13,
			width: 5,
			height: 5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6 13.2422H10.7883V18.0014H6V13.2422Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask2_23485_81864)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M7.4001 17.9975H10.1241C10.4549 17.9975 10.724 17.7284 10.724 17.3976C10.724 17.0668 10.4549 16.7977 10.1241 16.7977H7.4001C7.2897 16.7977 7.19982 16.7078 7.19982 16.5974V13.8734C7.19982 13.5426 6.93066 13.2734 6.59991 13.2734C6.26916 13.2734 6 13.5426 6 13.8734V16.5974C6 17.3693 6.6282 17.9975 7.4001 17.9975Z",
				fill: "white"
			})
		})
	]
});
export default SvgFullScreen;
